(function() {
    'use strict';
    
a3_cabin_reports.controller('SpecialMealIssueCtrl', SpecialMealIssueCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SpecialMealIssueCtrl
    * @description 
    *  Manages the Special Modal View
    * @ngInject
    */
function SpecialMealIssueCtrl($scope, $timeout, $uibModalInstance, ModalDialogResultFactory, SpecialMealIssueFactory, SpecialMealTypeFactory, SpecialMealSourceFactory, smi) {

		// setup special meal types
		var smts = SpecialMealTypeFactory.getSpecialMealTypesFromStorageAsStrings();
		if (!(smts instanceof Array)) smts = [];
		$scope.specialMealTypes = smts;

		// setup datetime picker
		$scope.dateOptions = {
			formatYear: 'yyyy',
			startingDay: 1
		};

		$scope.opened = false;
		$scope.open = function($event) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.opened = true;
		}

		// setup special meal sources
		var smss = SpecialMealSourceFactory.getSpecialMealSourcesFromStorageAsStrings();
		if (!(smss instanceof Array)) smss = [];
		$scope.specialMealSources = smss;

		$scope.clearField = clearField;
        $scope.clearSpecialMealIssueRemarks = clearSpecialMealIssueRemarks;  
    


		var result = ModalDialogResultFactory.createNew();

		if (smi == null) {
			result.Object = SpecialMealIssueFactory.createNew();
			result.isInsertMode = true;
		} else {
			result.Object = SpecialMealIssueFactory.fromObject(smi);
            if(smi.ReturnDate){
                result.Object.ReturnDate= new Date(smi.ReturnDate);
                }
            result.isInsertMode = false;
		}

		$scope.smi = result.Object;

		$scope.ok = ok;
        $scope.cancel = cancel;
    
        $timeout(function() {
			$('.modal-special').find('textarea').each(function(index, item) {
				if (item.value != '')
					autoAdjustTextarea(item);
			});
		}, 500);
    
        /**
         * Clear Field
         * @memberof SpecialMealIssueCtrl
         */
        function clearField(target, fieldName) {
			if (target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function() {}
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function() {
							target[fieldName] = null;
							$scope.$apply();
							return true;
						}
					}
				}
			});
		}

        
        /**
         * Clear Special Meal Issue remarks
         * @memberof SpecialMealIssueCtrl
         */
        function clearSpecialMealIssueRemarks(smi) {
			$scope.clearField(smi, "Remarks");
			//sup.Remarks = null;
		}
    
        /**
         * set date and close modal
         * @memberof SpecialMealIssueCtrl
         */
        function ok() {
			if ((result.Object.Name == null) || (result.Object.Name == ''))
				result.Object.Name = '-';

			if ($scope.smi.ReturnDate != null) {
				var date = new Date($scope.smi.ReturnDate);
				var offset = date.getTimezoneOffset() / 60;
				var hours = date.getHours();
				date.setHours(hours - offset);

				result.Object.ReturnDate = date.toISOString();
			}

			$uibModalInstance.close(result);
		}

        /**
         * Close modal after u check position
         * @memberof SpecialMealIssueCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}



	}

})();
